module.exports = __webpack_public_path__ + "static/media/database.c6259ad7.png";